import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";
import { IReceiptReport } from "./recieptypes";
import { IStudent } from "../student/student.types";

export const FETCH_RECIEPT_REPORT_LIST_PROGRESS =
  "FETCH_RECIEPT_REPORT_LIST_PROGRESS";
export const FETCH_RECIEPT_REPORT_LIST_SUCCESS =
  "FETCH_RECIEPT_REPORT_LIST_SUCCESS";
export const FETCH_RECIEPT_REPORT_LIST_FAILED =
  "FETCH_RECIEPT_REPORT_LIST_FAILED";

export const fetchRecieptReportListProgress = () =>
  action(FETCH_RECIEPT_REPORT_LIST_PROGRESS);

export const fetchRecieptReportListSuccess = (
  data: IReceiptReport[],
  singleReport: IReceiptReport,
  totalRecords: number,
  totalPaidFee: number
) =>
  action(FETCH_RECIEPT_REPORT_LIST_SUCCESS, {
    data,
    singleReport,
    totalRecords,
    totalPaidFee,
  });

export const fetchrecieptReportListFailed = () =>
  action(FETCH_RECIEPT_REPORT_LIST_FAILED);

export const fetchRecieptReportListAsync =
  (
    date: IDataTableV2DateState["dates"],
 
    organizationUUID: string,
    courseUUID?: string,
    batch?: string,
    acedmicYear?: number,
    studentUUID?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRecieptReportListProgress());

      let url = "";
      if (organizationUUID) {
        url += `&organizations_uuid=${organizationUUID}`;
      }
      if (courseUUID) {
        url += `&courses_uuid=${courseUUID}`;
      }
      if (batch) {
        url += `&batch=${batch}`;
      }
      // if (selectStudent) {
      //   url += `&customer_fact_uuid=${selectStudent}`;
      // }
      if (acedmicYear) {
        url += `&academic_year=${acedmicYear}`;
      }
      if (studentUUID) {
        url += `&customer_fact_uuid=${studentUUID}`;
      }
      const res = await api.get(
        `report/get-receipt-list?&from_date=${date.fromDate}&to_date=${date.toDate}` +
          url
      );

      const data: IReceiptReport[] = res.data.data.result;
      const totalPaidFee = res.data.data.total_paid_fee;

      console.log("totalPaidFeeeeeeeeeeeeeeeeee", totalPaidFee);
      console.log("data:", data);

      const singleReport = res.data.data[0];
      const totalRecords = res.data.totalRecords;
      dispatch(
        fetchRecieptReportListSuccess(
          data,
          singleReport,
          totalRecords,
          totalPaidFee
        )
      );
    } catch (error: any) {
      dispatch(fetchrecieptReportListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_RECIEPT_REPORT_STATE = "CLEAR_RECIEPT_REPORT_STATE";
export const CLEAR_RECIEPT_REPORT = "CLEAR_RECIEPT_REPORT";

export const clearRecieptReportState = () => action(CLEAR_RECIEPT_REPORT_STATE);
export const clearRecieptReport = () => action(CLEAR_RECIEPT_REPORT);
